import React, { Component } from "react";
import { Tooltip } from "react-tooltip";
import logo from "../../img/zonda-high-resolution-logo-transparent.png";
import { IoMdMoon, IoMdSunny } from "react-icons/io";
import { HiOutlineDocumentText } from 'react-icons/hi'
import { HiOutlineBugAnt } from "react-icons/hi2";
import Toggle from "../toggle/booleanToggle";
import "./header.css";

class Header extends Component {
    render() {
        const { darkmode, advancedmode, toggleDarkmode, toggleAdvancedmode } = this.props;
        return (
            <div className="header">
                <div className="left">
                    <div className="logo">
                        <img src={logo} alt="Logo" />
                    </div>
                    <div className="title">ICON Grid & EXTPAR Interface
                        <div className="git-tag">
                            <a href={`https://github.com/C2SM/zonda-frontend/releases/tag/${process.env.REACT_APP_GIT_TAG}`}
                                target="_blank"
                                rel="noopener noreferrer">{process.env.REACT_APP_GIT_TAG || "Unknown Tag"}</a>
                        </div>
                    </div>
                </div>
                <div className="right">
                    <Tooltip id={"tooltip"} />
                    <Toggle
                        config={{
                            fieldname: "advancedmode",
                            tooltip: "Hides / shows advanced options",
                            tooltipType: "top-bar"
                        }}
                        right={"Expert"}
                        left={"Basic"}
                        state={advancedmode}
                        setStateField={() => toggleAdvancedmode()}
                    />
                    <Tooltip id={"darkmode-tooltip"} />
                    <div className={"darkmode-toggle"} onClick={toggleDarkmode}>
                        {darkmode ?
                            <IoMdMoon
                                size={"32px"}
                                className="darkmode-icon"
                                data-tooltip-id={"darkmode-tooltip"}
                                data-tooltip-place={"bottom"}
                                data-tooltip-html={"Switch to light mode"}
                            /> :
                            <IoMdSunny
                                size={"32px"}
                                className="darkmode-icon"
                                data-tooltip-id={"darkmode-tooltip"}
                                data-tooltip-place={"bottom"}
                                data-tooltip-html={"Switch to dark mode"}
                            />
                        }
                    </div>
                    <Tooltip id={"docs-tooltip"} />
                    <HiOutlineDocumentText
                        size={"32px"}
                        className="docs-icon"
                        onClick={() => window.open("https://c2sm.github.io/zonda-frontend/")}
                        data-tooltip-id={"docs-tooltip"}
                        data-tooltip-place={"bottom"}
                        data-tooltip-html={"Zonda documentation"}
                    />
                    <Tooltip id={"bug-tooltip"} />
                    <HiOutlineBugAnt
                        size={"32px"}
                        className="bug-icon"
                        onClick={() => window.open("https://github.com/C2SM/zonda-request/issues/new?template=bug_report.yml")}
                        data-tooltip-id={"bug-tooltip"}
                        data-tooltip-place={"bottom"}
                        data-tooltip-html={"Report a bug"}
                    />
                </div>
            </div>
        );
    }
}

export default Header;
